import axios from 'axios';
import { security_key } from './Api';

export const uploadImage = async (formData, apiEndpoint, setUploadedStates) => {

    // Read fresh on every call — not at module load time — so a token
    // that didn't exist yet when this file was imported (e.g. user logs
    // in after page load) is picked up correctly.
    const token = sessionStorage.getItem('authToken');

    const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
    };

    for (const [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
    }

    try {
        const response = await axios.post(apiEndpoint, formData, { headers });

        const result = response.data;
        setUploadedStates('Upload Successful');
        console.log("upload result", result);
        alert('Upload Successful');

    } catch (error) {
        console.log("error", error);
        setUploadedStates(`Upload Failed: ${error.message}`);
    }
};